export default __webpack_public_path__ + "static/media/bare metal comp.5a646c15.png";